import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7faf4708")

_pushScopeId("data-v-7faf4708")
const _hoisted_1 = { class: "scoreRanking pt32" }
const _hoisted_2 = {
  key: 0,
  class: "tabAnalysis tabContent"
}
const _hoisted_3 = { class: "publishStates" }
const _hoisted_4 = { class: "jobStatus" }
const _hoisted_5 = { class: "score" }
const _hoisted_6 = { class: "score" }
const _hoisted_7 = { class: "action flex align-items-center" }
const _hoisted_8 = {
  key: 1,
  class: "tabRanking tabContent"
}
const _hoisted_9 = { class: "publishStates" }
const _hoisted_10 = { class: "status" }
const _hoisted_11 = { class: "caseModule" }
const _hoisted_12 = { class: "experimentScore" }
const _hoisted_13 = { class: "experimentRank" }
const _hoisted_14 = { class: "action flex align-items-center" }
const _hoisted_15 = {
  key: 0,
  class: "tabFoot"
}
const _hoisted_16 = {
  key: 1,
  class: "tabFoot"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ui_tab_framework_vue = _resolveComponent("ui-tab-framework-vue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ui_tab_framework_vue, {
      tabs: _ctx.tabArr,
      active: _ctx.activeTab,
      "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = $event))
    }, {
      content: _withId(() => [
        (_ctx.activeTab === _ctx.tabArr[0])
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_a_table, {
                "row-key": "id",
                pagination: false,
                loading: _ctx.tableLoadingAnalysis,
                "data-source": _ctx.tableListAnalysis,
                columns: _ctx.columnsAnalysis
              }, {
                assignmentModel: _withId(({record}) => [
                  _createVNode("div", _hoisted_3, _toDisplayString(record.assignmentModel === 1  ? '考核模式' : '练习模式'), 1)
                ]),
                jobStatus: _withId(({record}) => [
                  _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getJobStatus(record)), 1)
                ]),
                score: _withId(({record}) => [
                  _createVNode("div", _hoisted_5, _toDisplayString(record.score ?? '-'), 1)
                ]),
                ranking: _withId(({record}) => [
                  _createVNode("div", _hoisted_6, _toDisplayString([undefined, -1].includes(record.ranking) ? '-' : record.ranking), 1)
                ]),
                action: _withId(({record}) => [
                  _createVNode("div", _hoisted_7, [
                    (record.publishStates)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: ["text-btn pointer mr8", {'disabled-txt': !_ctx.isRanking(record)}],
                          onClick: ($event: any) => (_ctx.isRanking(record) && _ctx.gotoInfoAnalysis(record))
                        }, "查看", 10, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "data-source", "columns"])
            ]))
          : (_ctx.activeTab === _ctx.tabArr[1])
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode(_component_a_table, {
                  "row-key": "id",
                  pagination: false,
                  loading: _ctx.tableLoading,
                  "data-source": _ctx.tableList,
                  columns: _ctx.columns
                }, {
                  experimentModel: _withId(({record}) => [
                    _createVNode("div", _hoisted_9, _toDisplayString(record.experimentModel === 1  ? '考核模式' : '练习模式'), 1)
                  ]),
                  status: _withId(({record}) => [
                    _createVNode("div", _hoisted_10, _toDisplayString(_ctx.expStatus(record)), 1)
                  ]),
                  caseModule: _withId(({record}) => [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.caseModuleArr[record.caseModule]), 1)
                  ]),
                  experimentScore: _withId(({record}) => [
                    _createVNode("div", _hoisted_12, _toDisplayString(record.experimentScore ?? '-'), 1)
                  ]),
                  experimentRank: _withId(({record}) => [
                    _createVNode("div", _hoisted_13, _toDisplayString(record.experimentRank ?? '-'), 1)
                  ]),
                  action: _withId(({record}) => [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", {
                        class: ["text-btn pointer mr8", {'disabled-txt': _ctx.stuStatus(record)}],
                        onClick: ($event: any) => (!_ctx.stuStatus(record) && _ctx.gotoInfo(record))
                      }, "查看", 10, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "data-source", "columns"])
              ]))
            : _createCommentVNode("", true)
      ]),
      foot: _withId(() => [
        (_ctx.activeTab === _ctx.tabArr[0])
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode(_component_a_pagination, {
                class: "page",
                current: _ctx.pageNoAnalysis,
                "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageNoAnalysis = $event)),
                pageSize: _ctx.pageSizeAnalysis,
                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageSizeAnalysis = $event)),
                total: _ctx.totalAnalysis,
                showSizeChanger: "",
                "show-quick-jumper": "",
                onChange: _ctx.pageChangeAnalysis,
                onShowSizeChange: _ctx.showSizeChangeAnalysis
              }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
            ]))
          : (_ctx.activeTab === _ctx.tabArr[1])
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode(_component_a_pagination, {
                  class: "page",
                  current: _ctx.pageNo,
                  "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pageNo = $event)),
                  pageSize: _ctx.pageSize,
                  "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => (_ctx.pageSize = $event)),
                  total: _ctx.total,
                  showSizeChanger: "",
                  "show-quick-jumper": "",
                  onChange: _ctx.pageChange,
                  onShowSizeChange: _ctx.showSizeChange
                }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["tabs", "active"])
  ]))
})